export interface MagnetSite {
  id: string;
  title: string;
  slug: string;
  category: string;
  description: string;
  url: string;
  imageUrl: string;
  thumbUrl: string;
  rating: number;
  speed: string;
  stability: string;
  resources: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  addedDate: string;
  content: string;
  pros: string[];
  cons: string[];
}

export const magnetSites: MagnetSite[] = [
  {
    id: '1',
    title: '磁力猫',
    slug: 'cilimao',
    category: 'yingshi',
    description: '老牌磁力搜索引擎，资源库庞大，支持关键词精准搜索，日更新影视资源超千部，是国内最受欢迎的磁力网站之一。',
    url: 'https://www.cilimao.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-cilimao&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-cilimao-thumb&orientation=landscape',
    rating: 4.8,
    speed: '极快',
    stability: '高',
    resources: '1000万+',
    tags: ['影视', '磁力搜索', '热门推荐'],
    featured: true,
    isNew: false,
    addedDate: '2024-01-15',
    content: '磁力猫是国内老牌的磁力搜索引擎，成立于2018年，拥有海量的磁力链接资源库。平台支持关键词搜索、分类浏览、热门推荐等多种查找方式，资源涵盖电影、电视剧、综艺、动漫、纪录片等多个品类。磁力猫以其快速的更新速度和稳定的服务赢得了大量用户的信赖，日均访问量超过百万。平台界面简洁易用，支持移动端访问，是寻找影视磁力资源的首选网站。',
    pros: ['资源更新速度快', '搜索精准度高', '界面简洁友好', '支持移动端'],
    cons: ['部分资源需注册', '广告较多'],
  },
  {
    id: '2',
    title: 'BT之家',
    slug: 'btzhijia',
    category: 'yingshi',
    description: '老牌BT磁力资源分享论坛，社区活跃，资源涵盖影视、软件、游戏等多领域，用户评价体系完善。',
    url: 'https://www.btzhijia.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-btzhijia&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-btzhijia-thumb&orientation=landscape',
    rating: 4.6,
    speed: '快',
    stability: '高',
    resources: '800万+',
    tags: ['影视', '软件', '游戏', '论坛'],
    featured: true,
    isNew: false,
    addedDate: '2024-02-20',
    content: 'BT之家是国内知名的BT磁力资源共享论坛，拥有庞大的用户社区和活跃的分享氛围。网站涵盖影视、软件、游戏、音乐等多个资源板块，每个板块都有专人维护和更新。BT之家的特色在于用户评价和打分系统，帮助其他用户快速识别优质资源和垃圾链接。论坛还设有新手教程区、问题反馈区等，用户体验完善。经过多年发展，BT之家已成为磁力资源分享领域的重要平台。',
    pros: ['社区活跃度高', '资源种类丰富', '用户评价系统好', '教程完善'],
    cons: ['新手需要适应论坛模式', '部分板块需要等级'],
  },
  {
    id: '3',
    title: '磁力湾',
    slug: 'ciliwan',
    category: 'yingshi',
    description: '新一代磁力搜索平台，采用AI智能推荐算法，根据用户偏好精准推送资源，体验流畅。',
    url: 'https://www.ciliwan.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-ciliwan&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-ciliwan-thumb&orientation=landscape',
    rating: 4.5,
    speed: '极快',
    stability: '中',
    resources: '600万+',
    tags: ['影视', 'AI推荐', '新站'],
    featured: true,
    isNew: true,
    addedDate: '2025-03-10',
    content: '磁力湾是2024年上线的新一代磁力搜索平台，主打AI智能推荐和个性化体验。平台通过分析用户的搜索和浏览行为，智能推荐用户可能感兴趣的磁力资源。磁力湾的搜索算法经过深度优化，支持模糊搜索、同义词匹配等高级功能。网站设计现代美观，加载速度快，支持暗黑模式。虽然上线时间不长，但凭借出色的用户体验迅速积累了大量忠实用户。',
    pros: ['AI智能推荐', '界面现代美观', '搜索功能强大', '支持暗黑模式'],
    cons: ['资源库相对较小', '稳定性有待提升'],
  },
  {
    id: '4',
    title: '磁力搜搜',
    slug: 'cilisousou',
    category: 'yingshi',
    description: '聚合型磁力搜索引擎，同时检索多个磁力源站，一站式找到最全资源，省时省力。',
    url: 'https://www.cilisousou.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-cilisousou&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-cilisousou-thumb&orientation=landscape',
    rating: 4.4,
    speed: '快',
    stability: '高',
    resources: '2000万+',
    tags: ['影视', '聚合搜索', '多源'],
    featured: true,
    isNew: false,
    addedDate: '2024-06-01',
    content: '磁力搜搜是一款聚合型磁力搜索引擎，它同时从多个磁力源站检索结果并汇总展示，让用户一次搜索即可覆盖全网资源。平台支持的磁力源站超过20个，搜索结果去重合并后展示，极大提高了查找效率。磁力搜搜还提供了资源预览功能，用户可以在下载前查看资源的详细信息。对于追求效率和全量的用户来说，磁力搜搜是不可多得的好工具。',
    pros: ['聚合多源搜索', '搜索结果全面', '资源预览功能', '去重合并展示'],
    cons: ['搜索速度偶尔较慢', '部分源不稳定'],
  },
  {
    id: '5',
    title: '软件仓库磁力站',
    slug: 'ruanjian-cangku',
    category: 'ruanjian',
    description: '专注软件资源的磁力下载站，收录各类办公软件、设计工具、开发环境等，分类清晰。',
    url: 'https://www.soft-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-softcili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-softcili-thumb&orientation=landscape',
    rating: 4.3,
    speed: '快',
    stability: '高',
    resources: '300万+',
    tags: ['软件', '工具', '办公'],
    featured: true,
    isNew: false,
    addedDate: '2024-04-12',
    content: '软件仓库磁力站是一个专注于软件资源的磁力下载导航平台。网站按软件类别精心分类，包括办公软件、设计工具、编程开发、系统工具、安全软件等数十个大类。每个软件资源都配有详细的版本信息、系统要求和安装说明，方便用户选择合适的版本。网站更新及时，新版本发布后通常能在24小时内收录。对于需要查找特定软件的用户来说，这是一个非常实用的资源站。',
    pros: ['软件分类清晰', '版本信息详细', '更新及时', '安装说明完善'],
    cons: ['软件种类有限', '部分冷门软件缺失'],
  },
  {
    id: '6',
    title: '游戏磁力大全',
    slug: 'youxi-cili',
    category: 'youxi',
    description: '专业游戏磁力资源站，收录3A大作、独立游戏、模拟器ROM等，游戏玩家必备导航。',
    url: 'https://www.game-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-gamecili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-gamecili-thumb&orientation=landscape',
    rating: 4.7,
    speed: '快',
    stability: '高',
    resources: '500万+',
    tags: ['游戏', '3A大作', '模拟器'],
    featured: true,
    isNew: false,
    addedDate: '2024-03-08',
    content: '游戏磁力大全是一个为游戏玩家量身打造的磁力资源导航平台。网站收录了大量热门游戏的磁力下载链接，涵盖PC单机游戏、主机游戏ROM、模拟器游戏、独立游戏等多个品类。每个游戏资源都标注了版本号、中文汉化情况、配置要求等关键信息。网站还有专门的游戏评测板块，帮助玩家了解游戏品质。对于喜欢尝试各种游戏的玩家来说，这是一个不可多得的资源宝库。',
    pros: ['游戏资源丰富', '信息标注详细', '有游戏评测', '更新频率高'],
    cons: ['大型游戏种子速度波动', '部分老游戏链接失效'],
  },
  {
    id: '7',
    title: '音乐磁力岛',
    slug: 'yinyue-cili',
    category: 'yinyue',
    description: '高品质音乐磁力资源站，主打无损音质，收录华语、欧美、日韩等全球音乐资源。',
    url: 'https://www.music-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-musiccili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-musiccili-thumb&orientation=landscape',
    rating: 4.5,
    speed: '中',
    stability: '高',
    resources: '400万+',
    tags: ['音乐', '无损', '专辑'],
    featured: false,
    isNew: true,
    addedDate: '2025-01-20',
    content: '音乐磁力岛是一个专注于高品质音乐资源的磁力下载导航网站。平台主打无损音质，收录了FLAC、APE、WAV等格式的高品质音乐资源。涵盖华语流行、欧美经典、日韩潮流、古典音乐、影视原声等多种音乐类型。每个音乐资源都标注了音质格式、比特率等专业信息，方便发烧友选择。网站还设有音乐推荐和热歌榜单板块，帮助用户发现好音乐。',
    pros: ['音质标注清晰', '无损资源丰富', '分类细致', '有音乐推荐'],
    cons: ['下载速度一般', '小众音乐资源较少'],
  },
  {
    id: '8',
    title: '学霸磁力站',
    slug: 'xueba-cili',
    category: 'xuexi',
    description: '学习资源磁力导航，收录编程、设计、语言、考试等各类课程资源，终身学习好帮手。',
    url: 'https://www.xueba-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-xuebacili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-xuebacili-thumb&orientation=landscape',
    rating: 4.4,
    speed: '快',
    stability: '高',
    resources: '200万+',
    tags: ['学习', '课程', '教程'],
    featured: false,
    isNew: false,
    addedDate: '2024-08-15',
    content: '学霸磁力站是一个专注于学习教程资源的磁力导航平台。网站收录了大量优质的在线课程、视频教程、电子书等学习资源，涵盖编程开发、UI设计、外语学习、考研考证、职业技能等多个学习领域。资源来源包括国内外知名教育平台，质量有保障。网站还设有学习路径推荐，帮助初学者规划学习方向。对于想要自学的用户来说，学霸磁力站是非常实用的资源导航工具。',
    pros: ['学习资源丰富', '分类清晰', '有学习路径推荐', '资源质量好'],
    cons: ['部分课程更新不及时', '需要自行判断资源时效'],
  },
  {
    id: '9',
    title: '动漫磁力社',
    slug: 'dongman-cili',
    category: 'dongman',
    description: '动漫爱好者专属磁力站，收录日漫、国漫、美漫等最新番剧资源，更新速度快。',
    url: 'https://www.anime-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-animecili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-animecili-thumb&orientation=landscape',
    rating: 4.6,
    speed: '极快',
    stability: '高',
    resources: '350万+',
    tags: ['动漫', '番剧', '二次元'],
    featured: false,
    isNew: false,
    addedDate: '2024-05-22',
    content: '动漫磁力社是动漫爱好者的天堂，专注于收录各类动漫磁力资源。平台涵盖了日本动画、国产动漫、欧美动画等丰富的动漫资源，从经典老番到当季新番应有尽有。资源更新速度极快，日本新番播出后通常能在几小时内上线磁力链接。网站还提供了字幕组信息、画质说明等详细标注，方便动漫迷选择最佳版本下载。社区氛围良好，是二次元爱好者的聚集地。',
    pros: ['更新极快', '资源种类全', '标注信息详细', '社区氛围好'],
    cons: ['冷门老番资源较少', '部分资源需验证'],
  },
  {
    id: '10',
    title: '综艺磁力铺',
    slug: 'zongyi-cili',
    category: 'zongyi',
    description: '综艺节目磁力资源专站，收录国内外热门综艺、纪录片、真人秀等，每周更新。',
    url: 'https://www.zongyi-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-zongyicili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-zongyicili-thumb&orientation=landscape',
    rating: 4.2,
    speed: '快',
    stability: '中',
    resources: '150万+',
    tags: ['综艺', '纪录片', '真人秀'],
    featured: false,
    isNew: true,
    addedDate: '2025-02-14',
    content: '综艺磁力铺是一个专注于综艺节目和纪录片磁力资源的导航网站。平台收录了国内外热门综艺节目，包括中国各大卫视的王牌综艺、韩国热门综艺、欧美经典真人秀等。纪录片板块涵盖了BBC、国家地理、Discovery等知名制作方的精品纪录片。网站按周更新，确保用户能看到最新的节目资源。对于综艺爱好者和纪录片迷来说，这是一个非常方便的磁力资源入口。',
    pros: ['综艺种类齐全', '纪录片品质高', '按周更新', '分类合理'],
    cons: ['资源总量偏少', '小众综艺覆盖不足'],
  },
  {
    id: '11',
    title: '文档磁力库',
    slug: 'wendang-cili',
    category: 'ziliao',
    description: '电子书与文档磁力资源导航，收录各类电子书、期刊论文、行业报告等知识资源。',
    url: 'https://www.doc-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-doccili&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-doccili-thumb&orientation=landscape',
    rating: 4.3,
    speed: '中',
    stability: '高',
    resources: '250万+',
    tags: ['电子书', '论文', '文档'],
    featured: false,
    isNew: false,
    addedDate: '2024-09-28',
    content: '文档磁力库是一个知识型磁力资源导航平台，专注于收录各类电子书、学术论文、行业报告、技术文档等知识资源。平台按学科和领域做了细致的分类，包括计算机科学、人文社科、经济管理、医学健康、工程技术等。每个文档资源都标注了作者、出版社、年份等书目信息，方便用户确认资源内容。对于研究人员、学生和知识工作者来说，文档磁力库是获取知识资源的便捷通道。',
    pros: ['知识资源丰富', '书目信息完整', '学科分类专业', '适合学术用途'],
    cons: ['下载速度一般', '部分资源版权存疑'],
  },
  {
    id: '12',
    title: '全能磁力搜',
    slug: 'quanneng-cili',
    category: 'ruanjian',
    description: '综合性磁力搜索工具站，内置多个搜索引擎切换，支持影视、软件、游戏全品类搜索。',
    url: 'https://www.quanneng-cili.com',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20technology%20website%20interface%20with%20warm%20gradient%20accent%2C%20minimal%20digital%20platform%20design%2C%20soft%20lighting%20on%20abstract%20background%2C%20professional%20web%20service%20aesthetic%2C%20high%20quality%20UI%20mockup&width=600&height=320&seq=site-quanneng&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20website%20interface%20design%20with%20warm%20accent%20colors%2C%20minimal%20digital%20platform%20UI%2C%20professional%20web%20service%20mockup%2C%20soft%20abstract%20background%2C%20high%20quality&width=400&height=250&seq=site-quanneng-thumb&orientation=landscape',
    rating: 4.5,
    speed: '极快',
    stability: '高',
    resources: '1500万+',
    tags: ['综合', '多引擎', '全品类'],
    featured: true,
    isNew: true,
    addedDate: '2025-05-01',
    content: '全能磁力搜是一款功能强大的综合性磁力搜索平台，内置了多个知名磁力搜索引擎，用户可以一键切换搜索源。平台覆盖影视、软件、游戏、音乐、文档等全品类资源，真正做到一站式搜索。全能磁力搜的特色功能包括多引擎对比搜索、资源健康度检测、下载速度预估等，帮助用户做出最佳选择。网站还支持高级筛选功能，可按文件大小、发布时间、做种数等条件精确过滤。',
    pros: ['多引擎一键切换', '全品类覆盖', '健康度检测', '高级筛选强大'],
    cons: ['界面功能较多', '新用户需要适应'],
  },
];

export const getArticleBySlug = (slug: string) => magnetSites.find(s => s.slug === slug);

export const getArticlesByCategory = (categorySlug: string) =>
  magnetSites.filter(s => s.category === categorySlug);

export const getFeaturedArticles = () => magnetSites.filter(s => s.featured);

export const getNewArticles = () => magnetSites.filter(s => s.isNew);

export const getRelatedArticles = (currentSlug: string, category: string, limit: number = 4) =>
  magnetSites.filter(s => s.category === category && s.slug !== currentSlug).slice(0, limit);